// #460 (S3-exp, apontamento Ju 11/09) — achado Codex #539-e6c37cf0 (rodada 1,
// nonce ee675fcd): não havia teste EXECUTÁVEL do normalizador de exportação da
// "Simulação completa do Descarte Automático". Extraído de
// RuleBenefitReportModal.vue::exportSimulationToXLSX como função PURA (mesmo
// padrão já aprovado pelo árbitro no #538/#516 para benefitLogsDisplayMerge.js)
// para poder ser coberto com `require` puro no mocha, sem harness de componente
// Vue nem transpilação.
//
// Cada linha de entrada é { salary, benefit, beyondAllowedDiscard?, beyondReason? }
// — mesmo formato do descarte real (fullAutoDiscartSimulation.removedSalaries).
// `formatMoney`/`formatCoefficient` são INJETADOS (as mesmas funções do
// componente) para garantir formatação idêntica à da tela — este arquivo nunca
// reimplementa formatação própria.

const SIMULATION_EXPORT_HEADER = [
  'Mês',
  'Valor',
  'Valor Utilizado',
  'Índice de Atualização',
  'Remuneração Atualizada',
  'Média',
  'Valor Final',
  'Coeficiente',
  'Quantidade de Salários',
  'Além do limite',
  'Motivo',
];

/**
 * Monta UMA linha da planilha de exportação a partir de um item de
 * `fullAutoDiscartSimulation.removedSalaries`.
 *
 * @param {Object} row - { salary, benefit, beyondAllowedDiscard?, beyondReason? }
 * @param {Object} formatters - { formatMoney, formatCoefficient }
 * @returns {Array} linha na MESMA ordem de SIMULATION_EXPORT_HEADER.
 */
function buildSimulationExportRow(row, formatters) {
  const { formatMoney, formatCoefficient } = formatters || {};
  const salary = (row && row.salary) || {};
  const benefit = (row && row.benefit) || {};
  const logs = benefit.logs || {};

  return [
    `${salary.month}/${salary.year}`,
    `${formatMoney(salary.value)}`,
    `${formatMoney(salary.usedValue != null ? salary.usedValue : salary.value)}`,
    `${salary.update}`,
    `${formatMoney(salary.updatedValue)}`,
    logs.baseContribution != null ? `${formatMoney(logs.baseContribution)}` : '-',
    `${formatMoney(benefit.contribution)}`,
    `${formatCoefficient(logs.percentage)}%`,
    `${logs.count != null ? logs.count : ''}`,
    row && row.beyondAllowedDiscard ? 'Sim' : 'Não',
    row && row.beyondAllowedDiscard ? `${row.beyondReason || ''}` : '',
  ];
}

/**
 * Monta todas as linhas de dados (sem o cabeçalho) para
 * `fullAutoDiscartSimulation.removedSalaries`.
 */
function buildSimulationExportRows(rows, formatters) {
  return (rows || []).map((row) => buildSimulationExportRow(row, formatters));
}

/**
 * Monta a planilha completa (cabeçalho + linhas), no formato aoa (array de
 * arrays) que `XLSX.utils.aoa_to_sheet` espera.
 */
function buildSimulationExportSheetData(rows, formatters) {
  return [SIMULATION_EXPORT_HEADER, ...buildSimulationExportRows(rows, formatters)];
}

module.exports = {
  SIMULATION_EXPORT_HEADER,
  buildSimulationExportRow,
  buildSimulationExportRows,
  buildSimulationExportSheetData,
};
